const looksLikeEmail = (s) =>
  typeof s === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim());

const AGENT_EMAIL_DOMAINS = ["@serhant.com"];

export const normalizeEmail = (email) => {
  if (!looksLikeEmail(email)) return null;
  return email.trim().toLowerCase();
};

export const isMagicFurnishStaffEmail = (email) => {
  const norm = normalizeEmail(email);
  return norm ? norm.endsWith("@magicfurnish.com") : false;
};

export const isPartnerAgentEmail = (email, agentEmailDomain) => {
  const norm = normalizeEmail(email);
  if (!norm) return false;
  const domains = agentEmailDomain
    ? [String(agentEmailDomain).toLowerCase()]
    : AGENT_EMAIL_DOMAINS.map((suffix) => suffix.toLowerCase());
  return domains.some((suffix) => norm.endsWith(suffix));
};

/**
 * Audience hint mirrored on inquiry_submitted events. Conversion filtering
 * remains EventLog read-time insider exclusion — same as gallery views.
 *
 * @returns {'lead'|'agent'|'internal'}
 */
export const classifySessionAudience = ({
  isGuest,
  email,
  isInternal = false,
}) => {
  if (isGuest) return "lead";
  if (isInternal || isMagicFurnishStaffEmail(email)) return "internal";
  if (isPartnerAgentEmail(email)) return "agent";
  return "lead";
};
